import { skeletonStyles } from '@gonfalon/metric-events/Sources';
import clsx from 'clsx';

import styles from './EventActivitySearchResults.module.css';

export const EventActivitySearchResultSkeleton = () => (
  <div aria-hidden className={clsx(styles.eventItemContainer, styles.skeletonResult)}>
    <span className={skeletonStyles.skeleton}>&nbsp;</span>
    <div>
      <span className={skeletonStyles.skeleton} />
      <span className={skeletonStyles.skeleton}>&nbsp;</span>
    </div>
  </div>
);
